// BL598 Phase 2 — `grid delete <noun>` (kubectl-noun pattern).
//
// Replaces the deleted top-level `grid delete` (which only archived
// inspirations and partially duplicated unplug). `delete entity` keeps the
// inspiration-archive path; `delete grid` removes an owned, empty grid.

import { Command } from 'commander';
import { deleteGridCommand } from './grid.js';
import { deleteEntityCommand } from './entity.js';

export const deleteCommand = new Command('delete')
  .description('Delete a grid or archive an entity')
  .addCommand(deleteGridCommand)
  .addCommand(deleteEntityCommand);
